import React from 'react'
import NumberBox from 'Presentation/Components/Statistics/NumberBox'
import SmartCalendarButton from 'Presentation/Components/SmartCalendarButton'
import moment from 'moment'
import 'moment-timezone'
import 'moment/locale/th'
import clsx from 'clsx'

interface Props {
	weekRanges: {
		start: string
		end: string
	}[]
	startDate: string
	endDate: string
	onChangeState: (key: string, value: any) => void
}

const StatisticZone: React.FC<Props> = ({ weekRanges, startDate, endDate, onChangeState }) => {
	return (
		<div className="row justify-content-center">
			<div className="col-12 col-lg-6 mb-3">
				<NumberBox
					actionTitle="View Report"
					toolTip="customer"
					unitTooltip="บาท"
					name="Statistics"
					title="รอบบิลปัจจุบัน"
					value={345}
					unit={'บาท'}
					valueChangePercentage={1.3}
				/>
			</div>
			<div className="col-12 col-lg-6 mb-3">
				<div className="card h-10 border border-kumopack-grey-200">
					<div className="card-body px-4 py-4">
						<div className="d-flex flex-column justify-content-between px-0 h-100">
							{/* start:: Header */}
							<div className="row">
								<div className="col-12 col-lg-8">
									<p className="fs-6 fw-bolder my-0" style={{ color: '#373634' }}>
										รอบบิลประจำอาทิตย์
									</p>
								</div>
								<div className="col-12 col-lg-4 text-end">
									<SmartCalendarButton
										customBtnClass="btn btn-sm white-button w-fit-content"
										customIcon={
											<img
												src="/media/icons/kumopack/calendar.svg"
												alt="Kumopack Calendar Icon"
												width={20}
												height={20}
											/>
										}
										startDate={startDate}
										endDate={endDate}
										onChangeState={onChangeState}
									/>
								</div>
							</div>

							{/* Item */}
							{weekRanges.map((range, idx) => (
								<React.Fragment key={`marketplace-week-range-${idx + 1}`}>
									<div
										className={clsx('d-flex flex-row align-items-center justify-content-between', {
											'mt-5': idx === 0,
										})}>
										<div>
											{moment(range.start).tz('Asia/Bangkok').format('D MMM')} -{' '}
											{moment(range.end).tz('Asia/Bangkok').format('D MMM YYYY')}
										</div>
										<div>
											<button className="btn btn-sm btn-muted btn-active-light px-2 py-1">
												<img src="/media/icons/kumopack/green-download-01.svg" alt="download_img" />
												ดาวน์โหลด
											</button>
										</div>
									</div>
								</React.Fragment>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default StatisticZone
